import React, { Component } from 'react';
import firebase from 'firebase';
import './estilo.css';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import { Pulse } from 'react-preloading-component';

class CancelarViajes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viajes: [],
            showModal: false,
            justificacion: '',
            ruta: this.props.rutas || [],
            programacionesDia: [],
            empleados: [],
            bases: [],
            tipoV: [],
            isLoading: true
        }
    }

    componentDidMount = async () => {
        this.getData();
    }

    getFirstWord(s, separator) {
        let r = s.split(separator);
        return r[0];
    }

    getData = async () => {
        firebase.database().ref('Bases').once('value').then(snap => {
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            firebase.database().ref('Empleados').once('value').then(snap3 => {
                let empleados = [];
                snap3.forEach(element => {
                    let data = element.val();
                    data.key = element.key;
                    empleados.push(data);
                });
                this.setState({ empleados, bases, isLoading: false })
                this.getAsignacionViajes();
            })
        })
    }

    getAsignacionViajes = () => {
        let { bases, empleados } = this.state;
        firebase.database().ref().child('AsignacionViajes').orderByChild('viajeFinalizado').equalTo(false).on('value', snap => {
            let data = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                if (datos.conduc !== "") {
                    let fecha_Actual = new Date().toLocaleDateString();
                    let fecha_viajeAsig = new Date(datos.fecha).toLocaleDateString();
                    if (fecha_Actual === fecha_viajeAsig) {
                        if (datos.isCancel === false || datos.isCancel === undefined) {
                            let baseInicio = bases.find(v => v.key == datos.base);
                            let baseDestino = bases.find(v => v.key == datos.baseF);
                            let empleadoSelec = empleados.find(v => v.key == datos.conduc);
                            datos.baseInicio = baseInicio;
                            datos.baseDestino = baseDestino;
                            datos.empleadoSelec = empleadoSelec;
                            data.push(datos);
                        }
                    }
                }
            });
            this.setState({ viajes: data, isLoading: false });
        });
    }

    showModal(ruta) {
        this.setState({ showModal: true, ruta, isLoading: false });
    }

    handleChange(data) {
        this.setState({ justificacion: data.target.value, isLoading: false })
    }

    cancelarViaje() {
        let { ruta, justificacion } = this.state;
        if (justificacion !== '') {
            if (ruta.conductor !== '') {
                firebase.database().ref('Empleados').child(ruta.conduc).update({ ViajeActualE: 'ninguno', viajeEmpresa: 'Disponible' });
                firebase.database().ref('AsignacionViajes').child(ruta.key).update({ isCancel: true, conduc: '', tipoVe: '' });
                firebase.database().ref('ProgramacionDia').child(ruta.prograDia).update({ estado: 'Cancelado', justificacion });
                Alert.success('Viaje cancelado con éxito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            } else {
                Alert.warning('Imposible cancelar viaje debido a que no posee conductor asignado', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            }
            this.setState({ justificacion: '', showModal: false, isLoading: false });
        } else {
            Alert.warning('Por favor, justifique la cancelación del viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
        }
    }

    liberarViajes(data) {
        firebase.database().ref('Empleados').child(data.conduc).update({ ViajeActualE: 'ninguno', viajeEmpresa: 'Disponible' });
        firebase.database().ref('AsignacionViajes').child(data.key).update({ isCancel: false, conduc: '', tipoVe: '' });
        firebase.database().ref('ProgramacionDia').child(data.prograDia).update({ estado: 'Pendiente', justificacion: '' });
        Alert.success('Viaje liberado con éxito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
    }

    render() {
        const { isLoading, viajes } = this.state;

        return (
            <div className="container">
                <div className="row justify-content-md-center">
                    <div className="col-12" style={{ marginTop: '2%' }}>
                        <div style={{ minHeight: '300px' }} className="table-responsive text-center">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Hora de Partida</th>
                                        <th>Origen</th>
                                        <th>Destino</th>
                                        <th>Conductor Asignado</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: 'center' }}>
                                                <Pulse />
                                            </td>
                                        </tr>
                                    ) : (
                                        viajes.map((index, data) => {
                                            //console.log(index);
                                            return (
                                                <tr id={index} key={'reserva' + index}>
                                                    <td>{index.horaProgra || "-"}</td>
                                                    <td>{index.baseInicio.Nombre || "-"}</td>
                                                    <td>{index.baseDestino.Nombre || "-"}</td>
                                                    <td>{index.empleadoSelec.nombre || "-"}</td>
                                                    <td>
                                                        <button style={{ marginRight: 3 }} onClick={() => this.showModal(index)} className="btn btn-small btn-danger">Cancelar Viaje</button>
                                                        <button style={{ marginLeft: 3 }} onClick={() => this.liberarViajes(index)} className="btn btn-small btn-info">Liberar Viaje</button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Modal key='modal' isOpen={this.state.showModal} onRequestClose={() => this.setState({ showModal: false, isLoading: false })} style={customStyles}>
                    <div style={{ marginTop: 10 }} className="row">
                        <div className="col-12">
                            <h3 className="title-blue" style={{ marginBottom: '2%' }}>Cancelar viaje</h3>
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <textarea style={{ minHeight: '75%' }} placeholder='Motivo de la cancelación' onChange={this.handleChange.bind(this)} className="form-control form-control-bg"></textarea>
                                </div>
                                <div className="col-12 col-md-12">
                                    <button onClick={() => this.cancelarViaje()} className="btn btn-red float-right">Continuar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '200px',
    }
}

export default CancelarViajes;


// WEBPACK FOOTER //
// ./src/Components/Planificacion/cancelarViajes.js